import { SNOWAttributeType } from '@amzn/snow-nxt-workflow-service-typescript-client';

interface AttributeTypeCarrier {
	attributeType?: string;
}

interface MandatoryCarrier {
	mandatory?: boolean;
}

export const isAttributeMandatory = (attribute: MandatoryCarrier): boolean =>
	attribute.mandatory ?? true;

export const isGlobalAttribute = (attribute: AttributeTypeCarrier): boolean =>
	attribute.attributeType === SNOWAttributeType.GLOBAL_ATTRIBUTE;

export const isWorkflowSpecificAttribute = (
	attribute: AttributeTypeCarrier
): boolean =>
	attribute.attributeType === SNOWAttributeType.WORKFLOW_SPECIFIC_ATTRIBUTE;

export const isTaskSpecificAttribute = (
	attribute: AttributeTypeCarrier
): boolean =>
	attribute.attributeType === SNOWAttributeType.TASK_SPECIFIC_ATTRIBUTE;

export const isDerivedAttribute = (attribute: AttributeTypeCarrier): boolean =>
	attribute.attributeType === SNOWAttributeType.DERIVED_ATTRIBUTE;

export const isWorkflowScopedAttribute = (
	attribute: AttributeTypeCarrier
): boolean =>
	isGlobalAttribute(attribute) || isWorkflowSpecificAttribute(attribute);

export const isEmptyAttributeValue = (value: unknown): boolean => {
	if (value === null || value === undefined) {
		return true;
	}

	if (typeof value === 'string') {
		return value.trim() === '';
	}

	return false;
};

export const getAttributeScopeLabel = (
	attribute: AttributeTypeCarrier
): string => {
	switch (attribute.attributeType) {
	case SNOWAttributeType.GLOBAL_ATTRIBUTE: return 'Global';
	case SNOWAttributeType.WORKFLOW_SPECIFIC_ATTRIBUTE: return 'Workflow';
	case SNOWAttributeType.TASK_SPECIFIC_ATTRIBUTE: return 'Task';
	case SNOWAttributeType.DERIVED_ATTRIBUTE: return 'Derived';
	default: return attribute.attributeType || '-';
	}
};
